import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import {Carousel} from 'react-responsive-carousel';
import coverImg from '../../../../assets/img/revamp/coverImg01.png'
import coverImg2 from '../../../../assets/img/institute/Banner Desktop.png'
import whyUs from '../../../../assets/img/revamp/edulab/CJ_Maths_WhyUS.png'
import './version01.scss'
import {Row, Col} from "reactstrap";
import webConfig from '../../../../config/WebConfig'
import {Icon} from '@iconify/react';
import TeacherTile from "../../../../components/TeacherTile/App";
import TimetableView from "../../../../components/Timetable/Timetable";
import VideoPlayerView from "../../../../components/YoutubePlayerViwe/VideoPlayerView";
import HowItsWork from "../../../../components/HowItsWork/HowItsWork";
import InquiryForm from "../../../../components/InquiryForm/InquiryForm";
import * as commonFunc from '../../../../utils/commonFunc'
import FAQ from "../../../../components/FAQ/FAQ";
import * as instituteService from '../../../../services/institute'
import * as actionSpinnerCreator from "../../../../store/domain/spinner/action";
import * as actionInstituteCreator from "../../../../store/domain/institute/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import HomeView from "./homeView/HomeView";
import * as constants from "../../../../const/constants";

class LandingLayout01 extends React.Component {

    state = {
        teacher: [],
        screenSize: 1440,
    };

    componentDidMount() {
        setTimeout(()=> {
            let hash = window.location.hash;
            if (hash) {
                const targetElement = document.querySelector(hash);
                if (targetElement) {
                    targetElement.scrollIntoView({behavior: 'smooth'});
                }
            }
        },1000);

        this.setState({screenSize: window.innerWidth});
        if (webConfig.LMSStatus === "LMS") {
            this.fetchInstituteTeachers();
        } else {
            this.props.fetchTeachers(webConfig.teachersDetails)
        }
    }

    fetchInstituteTeachers = async () => {
        this.props.spinnerHandler({isSpin: true, type: 15});
        await instituteService.getInstituteTeachers()
            .then(response => {
                this.props.spinnerHandler(false);
                if (response.success) {
                    this.props.fetchTeachers(response.body.teachers);
                    this.setState({teachers: response.body.teachers})
                } else {
                    commonFunc.notifyMessage(response.message, response.status)
                }
            })
    };

    viewAllTeacher = ()=>{
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_ALL_TEACHER_ROUTE}`)
    };


    render() {
        let {teachers,lmsStatus} = this.props;
        let {screenSize} = this.state;
        //Institute version 01
        return (
            teachers && <div className={'version01'}>
                <main>

                    <section>
                       <HomeView/>

                        <div id={'aboutUsSection'} className=" container pt-6 pb-6">
                            {screenSize > 768 ?
                                <Row>
                                    <Col xs={12} sm={12} md={12} lg={6}>
                                        <img className='whyUs-img ' src={whyUs}
                                             alt=""/>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={6}>
                                        <div className='whyUs-content-wrapper'>
                                            <h1>Why Us</h1>
                                            <p>{webConfig.whyUsPara}
                                            </p>

                                            <p className={'mt-1'}>{webConfig.whyUsSinhalaPara}</p>
                                            <div className='mt-3'>
                                                <h5 style={{color:'black'}}>Follow us</h5>
                                                <div className='justify-content-start' >
                                                    <a target={"_blank"} href={'https://www.facebook.com/CJ.chandikajayamaha?mibextid=ZbWKwL'}>
                                                        <Icon style={{color: `${webConfig.secondaryColor}`}}
                                                              height='30px' icon="bxl:facebook"/>
                                                    </a>
                                                    <a target={"_blank"} href={'https://youtube.com/@cjcombinedmathsofficial?si=6X5PHWFZIJj8joFh'}>
                                                        <Icon style={{color: `${webConfig.secondaryColor}`}}
                                                              className='mx-3' height='30px'
                                                              icon="akar-icons:youtube-fill"/>
                                                    </a>

                                                    <a target={"_blank"} href={'https://api.whatsapp.com/send?phone=94707683711'}>
                                                        <Icon style={{color: `${webConfig.secondaryColor}`}}
                                                              className='mx-2' height='30px'
                                                              icon="akar-icons:whatsapp-fill"/>
                                                    </a>

                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row> :
                                <Row>

                                    <Col xs={12} sm={12} md={12} lg={6}>
                                        <div className='whyUs-content-wrapper'>
                                            <h1>Why Us</h1>
                                            <p>{webConfig.whyUsPara}
                                            </p>
                                            <p className={'mt-1'}>{webConfig.whyUsSinhalaPara}</p>
                                            <div className='my-3'>
                                                <h5 style={{color:'black'}}>Follow us</h5>
                                                <div className='justify-content-start'>
                                                    <a target={"_blank"}
                                                       href={'https://www.facebook.com/CJ.chandikajayamaha?mibextid=ZbWKwL'}>
                                                        <Icon style={{color: `${webConfig.secondaryColor}`}}
                                                              height='30px' icon="bxl:facebook"/>
                                                    </a>
                                                    <a target={"_blank"}
                                                       href={'https://youtube.com/@cjcombinedmathsofficial?si=6X5PHWFZIJj8joFh'}>
                                                        <Icon style={{color: `${webConfig.secondaryColor}`}}
                                                              className='mx-3' height='30px'
                                                              icon="akar-icons:youtube-fill"/>
                                                    </a>

                                                    <a target={"_blank"}
                                                       href={'https://api.whatsapp.com/send?phone=94707683711'}>
                                                        <Icon style={{color: `${webConfig.secondaryColor}`}}
                                                              className='mx-2' height='30px'
                                                              icon="akar-icons:whatsapp-fill"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>

                                    <Col xs={12} sm={12} md={12} lg={6}>
                                        <img className='whyUs-img ' src={whyUs}
                                             alt=""/>
                                    </Col>

                                </Row>}
                        </div>

                        <div id='teachersSection' className="container teachers-wrapper pt-6 pb-6">
                            <Row>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <div className="teacher-topic-holder">
                                        <h1 className={'main-topic'}>
                                            Meet Our Teachers!
                                        </h1>
                                        <p className={' py-4'}>{webConfig.meetOurTeachersPara}</p>
                                        {/*<p className={' py-4'}>{webConfig.meetOurTeacherSinPara}</p>*/}
                                    </div>
                                </Col>
                            </Row>


                            <Row className='my-4'>
                                {teachers.map((teacher, index) =>
                                    index < 4 ? <TeacherTile key={index} teacher={teacher}/> : null)}
                            </Row>

                            {teachers.length > 4 ? <Row className='my-2'>
                                <Col sm={12} md={12} lg={12}>
                                    <p onClick={()=>this.viewAllTeacher()} className='text-center'   style={{color:webConfig.secondaryColor, cursor: "pointer"}}>See all teachers in {webConfig.InstituteName}<Icon
                                      style={{color:webConfig.secondaryColor}}
                                        className='mx-2'
                                        height='18px'
                                        icon="akar-icons:arrow-down"/>
                                    </p>
                                </Col>
                            </Row> : null}

                        </div>

                        {/*<TimetableView/>*/}
                        <VideoPlayerView landing  youtubeLikes={webConfig.youtubeRefVideoLink}/>
                        <HowItsWork desc={webConfig.howItsWorkPara} descSin={webConfig.howItsWorkParaSin}/>
                        <InquiryForm desc={webConfig.inquiryPara} descSin={webConfig.inquiryParaSin}/>
                        <FAQ desc={webConfig.FAQDesc} descSin={webConfig.FAQSINDesc} faq={webConfig.faq}/>

                    </section>
                </main>
            </div>
        )

    }
}


const mapStateToProps = (state) => ({
    institute: state.institute.institute,
    teachers: state.institute.teachers,
    userType: state.auth.userType,
});
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    fetchTeachers: data => dispatch(actionInstituteCreator.fetchTeachers(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LandingLayout01));
